export const variants = {
  TINY: '12px',
  BODY: '14px',
  SUB_HEAD: '25px',
  HEAD: '40px',
  LARGE: '64px',
  BOX_SHADOW: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',

  inputRadius: {
    SEARCH: '14px',
  },
  primary: '#0A4FAC',
  boxRadius: {
    SIDEBAR: '15px',
    NAVBAR: '15px',
    MAIN: '8px',
  },
  boxBackground: {
    SIDEBAR: '#fff',
    PROFILE_CARD: '#EEF5FF',
    NAVBAR: '#fff',
  },
  fontSize: {
    HEADER: '35px',
    LARGE: '22px',
    HEADING: '16px',
    SUB_HEADING: '14PX',
    TEXT: '12px',
  },
  icon: {
    active: {
      fontSize: '2.75rem',
      background: '#0A4FAC',
      p: 1,
      color: 'white',
      borderRadius: '10px',
    },
    inactive: {
      fontSize: '2.75rem',
      background: '#919EAB',
      p: 1,
      color: '#1C252E',
      borderRadius: '10px',
    },
  },
  color: {
    pending: 'rgb(250 188 43)',
    errorBackground: 'rgb(255 72 66 / 6%)',
    successBackground: 'rgb(84 214 44 / 6%)',
  },
  typography: {
    active: {
      main: '#0A4FAC',
      hover: 'rgba(0,0,0,0.7)',
    },
    inactive: {
      main: 'rgba(0,0,0,1)',
      hover: 'rgba(0,0,0,0.7)',
    },
  },
  hover: { active: '#EEF5FF', inactive: 'rgba(0,0,0,0.05)' },
};
